if (!localStorage.getItem('customer')) {
  const utmCookie = readCookie('utm_banner');
  console.log(utmCookie, 'COOKIE');
  const campaign = getUrlParameter('utm_campaign');

  /*************** UTM ANNOUNCEMENT BAR *************/
  // console.log(campaign); 
  function regex_escape(str) {
    if (str) {
      // console.log(str, 'STR');
      return str.replace(
        new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'),
        '\\$&'
      );
    }
  } 
  const utmBanners = document.querySelectorAll('[data-announcement-item]'); 
  const utmCTA = document.querySelector('[data-utm-header-cta]');

  if (utmBanners) { 
    if (utmCookie) {
      console.log(utmCookie, 'UTM COOKIE');
      const showBanners = document.querySelectorAll(`.utm-announcement-bar[data-ids="${utmCookie}"], .utm-tab[data-ids="${utmCookie}"]`);
      console.log(showBanners, 'SHOW BANNERS');

    if(showBanners.length > 0) {
      showBanners.forEach((banner) => {
        banner.classList.remove('hide');
        utmCTA.querySelector(`[data-ids="${utmCookie}"]`).classList.remove('hide');
      });
    } else {
      document.querySelector('.utm-announcement-bar[data-default]').classList.remove('hide');
      utmCTA.querySelector(`[data-ids="Default"]`).classList.remove('hide');
    }



    } else { 
      
      utmBanners.forEach((banner) => {
        const utms = banner.dataset.ids;
        console.log(utms, 'UTMS');
        const pattern = new RegExp(
          '\\b(?:' + regex_escape(utms).split(',').join('|') + ')\\b'
        );
        const result = pattern.test(campaign); 
        if (result) {
         // console.log(utms);
          utmCTA.querySelector(`[data-ids="${utms}"]`).classList.remove('hide');
          banner.classList.remove('hide');
          createCookie('utm_banner', utms, 7);
        } else {
          console.log('no match');
        }

      });

      if (testUTMs(utmBanners)) {
        document.querySelector('.utm-announcement-bar[data-default]').classList.remove('hide');
        utmCTA.querySelector(`[data-ids="Default"]`).classList.remove('hide');
       //document.querySelector('.utm-tab[data-default]').classList.remove('hide');
      }
    } 

    function testUTMs(banners) {
     //console.log('TEST UTMS');
      let valid = true;
      banners.forEach((banner) => {

        const utms = banner.dataset.ids
        const pattern = new RegExp(
          '\\b(?:' + regex_escape(utms).split(',').join('|') + ')\\b'
        );
        const result = pattern.test(campaign);
        //console.log(pattern, 'PATTERN');
        //console.log(result, 'RESULT');
        //console.log(regex_escape(campaign), 'campaign');

        if (result) {
          return (valid = false);
        }
      });
     // console.log('TEST is', valid)
      return valid;
    } 
    const flkty = Flickity.data('[data-announcement-slider]');
    flkty.resize(); 
   // console.log(flkty,'RESIZE THIS');
  }




  // COOKIES SET UP
  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name, "", -1);
  }

  // KLAVIYO SPECIFIC

  /*
    $('[data-klav-id]').on('click', function () {
      const klavID = $(this).data('klav-id');
      // console.log(klavID);
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', klavID]);
    });


    // REVEAL TAB
    /*
      function revealTab() {
  
          const tabOffset = windowHeight();
          const tab = $('.utm-tab');
  
          $('body').addClass('fixed-header');
          $(window).scroll(debounce(function () {
            checkPosition(tabOffset);
          }, 1));
  
          function checkPosition(tabOffset) { 
            scroll = $(window).scrollTop();
            // // console.log(tabOffset,'offset');
            // // console.log(scroll, 'Scroll');
            if (scroll > tabOffset) {
                tab.addClass('active'); 
            } else {
                tab.removeClass('active'); 
            }
          }
      }
      $(window).resize(debounce(function () {
          revealTab();
      }, 50));
      $(window).on('load', function () {
          revealTab();
      });
  */
}